import React from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { Link } from "react-router-dom";
import "../../Diagnostic/PackageDetail.css";
import CloseIcon from '@mui/icons-material/Close';
import WatchLaterOutlinedIcon from '@mui/icons-material/WatchLaterOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import EastOutlinedIcon from '@mui/icons-material/EastOutlined';
import PersonIcon from '@mui/icons-material/Person';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import WhyTrust from '../../layout/WhyTrust';
import StarOutlinedIcon from '@mui/icons-material/StarOutlined';
import CurrencyRupeeOutlinedIcon from '@mui/icons-material/CurrencyRupeeOutlined';

export default function LongTermCheckout() {
  return (
    <>
    <Header/>
      
     <div className="test_bredcum_sec">
             <div className="container-fluid">
                 <div className="test_bredcum">
                     <Link to="/">Home</Link>
                     <span>&gt;</span>
                     <span className='name_p'>CheckOut</span>
                 </div> 
             </div> 
         </div>

     <div className="checkout_main_pg">
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-7">

                    <div className="patient-info_checkout booking_box">
                        <h3>Patient Information</h3>
                        <div className="patient-info_checkout-mian">

                            <div className="info_icon_patient">
                                <div className="icon_info_pat">
                                    <PersonIcon/>
                                    <span>Name</span>
                                </div>
                                <h5>Manoj Deshmukh</h5>
                            </div>

                            <div className="info_icon_patient withbackground">
                                <div className="icon_info_pat">
                                    <LocalPhoneIcon/>
                                    <span>Phone Number</span>
                                </div>
                                <h5>+91-9876541238</h5>
                            </div>

                             <div className="info_icon_patient">
                                <div className="icon_info_pat">
                                    <PersonIcon/>
                                    <span>Age</span>
                                </div>
                                <h5>30Yrs</h5>
                            </div>
                            
                             <div className="info_icon_patient withbackground">
                                <div className="icon_info_pat">
                                    <PersonIcon/>
                                    <span>Gender</span>
                                </div>
                                <h5>Male</h5>
                            </div>

                             <div className="info_icon_patient">
                                <div className="icon_info_pat">
                                    <EmailOutlinedIcon/>
                                    <span>Email</span>
                                </div>
                                <h5>manoj@gmail.com</h5>
                            </div>

                             <div className="info_icon_patient withbackground">
                                <div className="icon_info_pat">
                                    <LocationOnIcon/>
                                    <span>Address</span>
                                </div>
                                <h5>15 Corner, Sector 10 Shopping Center Jaipur, Rajasthan, 302020</h5>
                            </div> 

                             <div className="info_icon_patient">
                                <div className="icon_info_pat">
                                    <CalendarMonthOutlinedIcon/>
                                    <span>Date</span>
                                </div>
                                <h5>April 31 2026</h5>
                            </div>

                             <div className="info_icon_patient withbackground">
                                <div className="icon_info_pat">
                                    <WatchLaterOutlinedIcon/>
                                    <span>Time</span>
                                </div>
                                <h5>07:00 AM</h5>
                            </div>

                             <div className="info_icon_patient">
                                <div className="icon_info_pat">
                                    <PersonIcon/>
                                    <span>Booking For</span>
                                </div>
                                <h5>Myself</h5>
                            </div> 
                            
                        </div>
                    </div>
                </div>
                <div className="col-lg-5">
                    <div className="long_term_chek_sumery">
                        <div className="uper_sec_header_long">
                            <h3>Your Care Plan Summary</h3>
                        </div>
                        <div className="sumery_content_longterm">
                            <div className="long_term_sev_nme">
                                <h4>Service Name</h4>
                                <h5>Basic Nursing Service</h5>
                            </div>
                             <div className="long_term_sev_nme">
                                <h4>Duration</h4>
                                <h5>7 Days</h5>
                            </div>
                             <div className="long_term_sev_nme">
                                <h4>Hours</h4>
                                <h5>8 Hours</h5>
                            </div>
                             <div className="long_term_sev_nme">
                                <h4>Shift</h4>
                                <h5>Morning (8 AM- 2 PM)</h5>
                            </div>
                        </div>
                    </div>

                    <div className="long_term_price">
                        <h2>Price</h2>
                        <div className="long_term_sev_nme">
                            <h4>Subtotal</h4>
                            <h5>₹999 </h5>
                        </div>
                        <div className="long_term_sev_nme">
                            <h4>Tax amount (3%)</h4>
                            <h5>₹49 </h5>
                        </div>
                        <div className="total_payable_longterm">
                            <h4>Total Payable</h4>
                            <h5>₹ 1,048/-</h5>
                        </div>
                    </div>

                    <div className="discount_section">
                        <input type="radio" id="recommended_plan" name="discount_plan" />

                        <label htmlFor="recommended_plan" className="discount_section_card">
                            <div className="discount_section_left">

                                <div className="discount_section_heading">
                                    <span className="discount_section_star">
                                        <StarOutlinedIcon/>
                                    </span>

                                    <h4>Recommended Plan</h4>

                                    <span className="discount_section_badge">
                                        Save ₹ 500 (20 % Off)
                                    </span>
                                </div>

                                <p>Book for 15 Days and get discount 20% off</p>

                            </div>

                            <div className="discount_section_price">
                                ₹ 1,500/-
                            </div>

                            <span className="discount_section_radio"></span>
                        </label>
                    </div>

                    <div className="payment_plan">
                        <h3 className='icon_pues'><CurrencyRupeeOutlinedIcon/> Choose Payment Plan</h3>
                        <p className='pera_pues'>Flexible payment options!</p>
                        <div className="payment_slect_sec">
                             <div className="row g-3">

                            <div className="col-4">
                                <div className="care_plan_box pyament_box">
                                <input type="radio" name="careplan" id="Quarterly" />
                                <label htmlFor="Quarterly">
                                    <span className="radio_circle"></span>  
                                    <h3>Quarterly</h3>
                                    <p className='first_pera_price'>Pay one fourth part</p>
                                    <h4>₹257/-</h4>
                                    <p className='second_pera_price'>per Quarter</p>
                                </label>
                                </div>
                            </div>

                             <div className="col-4">
                                <div className="care_plan_box pyament_box">
                                <input type="radio" name="careplan" id="HalfPay" />
                                <label htmlFor="HalfPay">
                                    <span className="radio_circle"></span>  
                                    <h3>Quarterly</h3>
                                    <p className='first_pera_price'>Pay one fourth part</p>
                                    <h4>₹257/-</h4>
                                    <p className='second_pera_price'>per Quarter</p>
                                </label>
                                </div>
                            </div>

                             <div className="col-4">
                                <div className="care_plan_box pyament_box">
                                <input type="radio" name="careplan" id="FullPay" />
                                <label htmlFor="FullPay">
                                    <span className="radio_circle"></span>  
                                    <h3>Quarterly</h3>
                                    <p className='first_pera_price'>Pay one fourth part</p>
                                    <h4>₹257/-</h4>
                                    <p className='second_pera_price'>per Quarter</p>
                                </label>
                                </div>
                            </div>

                            </div>
                        </div>
                    </div>

                    <div className="policy-btn-box booking_box summary_sec">
                        <div className="icon_content_pb">
                            <VerifiedUserOutlinedIcon/>
                            <div>
                                <h5>Your payment is Safe & Secure</h5>
                                <p>Easy cancellation & 100% refund on eligible cancellations.</p>
                            </div>
                        </div>
                        <div className='police_btn_booking'><a href="#">View Policy <KeyboardArrowRightOutlinedIcon/></a></div> 
                    </div>

                    <div className="total_payble booking_box total_amount_cot">
                        <div className="text_payble">
                            <p>Total Amount</p>
                            <h5>₹ 500/-</h5>
                            <p>(Inclusive of all taxes)</p>
                        </div>
                        <div className="book_now_payble">
                            <Link to="/ThankYou">Book Now <EastOutlinedIcon/></Link> 
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <WhyTrust/>
     </div>


    <Footer/>
    </>
  )
}
